import { useSyncExternalStore } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Chip } from '@mint-lib/tw-components';
import type { GridApi } from 'ag-grid-enterprise';

type SelectedRowsCounterProps = {
  readonly gridApi: GridApi | null;
};

export function SelectedRowsCounter({ gridApi }: SelectedRowsCounterProps) {
  const { t } = useTranslation('@mint-lib/ag-grid');

  const selectedRowsLength = useSyncExternalStore(
    // selectionChanged fires once per selection change, also for rows deselected off screen (rowSelected only fires for rendered rows).
    (callback) => {
      gridApi?.addEventListener('selectionChanged', callback);
      return () => gridApi?.removeEventListener('selectionChanged', callback);
    },
    () => gridApi?.getSelectedNodes().length ?? 0,
  );

  return (
    <Chip
      id="selected-rows-counter"
      color="azure"
      deletable
      onDelete={() => gridApi?.deselectAll()}
      className="order-first w-fit"
    >
      {t?.('{{count}} items', { count: selectedRowsLength })}
    </Chip>
  );
}
